<template>
  <v-toolbar
    flat
    color="white"
    class="viewToolbar"
  >
    <v-btn
      v-if="showBackButton"
      color="secondary"
      small
      text
      class="pr-0 pl-0"
      style="left:-14px"
      @click="onBackButton()"
    >
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    <v-toolbar-title class="text-button">
      <div class="text-button">{{ title }}</div>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <slot name="topRight"></slot>
    <v-tooltip
      left
      dark
      v-for="(button, index) of buttonsToUse"
      :key="index"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          color="secondary"
          small
          dark
          text
          class="mb-2 ml-2"
          @click="onButton(button)"
        >
          <v-icon :left="!!button.name">mdi-{{ button.icon }}</v-icon>
          <template v-if="!!button.name">
            {{ button.name }}
          </template>
          <!--
          <v-icon left>mdi-chevron-left</v-icon>
          {{ goBack }}
          -->
        </v-btn>
      </template>
      <span>{{ button.title }}</span>
    </v-tooltip>
  </v-toolbar>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    backRoute: {
      type: String,
      required: false
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    buttons: {
      type: Array,
      required: false
    },
  },
  computed: {
    buttonsToUse() {
      //we cannont mutate the prop btn_ar, so we do this
      let ar = []
      if (this.buttons) {
        for (let button of this.buttons) {
          ar.push(button)
        }
      }
      return ar
    }
  },
  methods: {
    onBackButton() {
      if (this.backRoute) {
        console.log("onBackButton backRoute", this.backRoute)
        this.$router.replace({ name: this.backRoute })
      } else {
        console.log("onBackButton history back")
        this.$router.back()
      }
    },
    onButton(button) {
      this.$emit('onButton', button)
    }
  },
  created() {
//    this.goBack = this.isEdit ? 'Avbryt' : 'Tillbaka'
  }
}
</script>

<style>
header.viewToolbar div.v-toolbar__content {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>